import RCTooltip from 'rc-tooltip';
import { TooltipProps } from 'rc-tooltip/lib/Tooltip';

interface Props extends TooltipProps {}

export const Tooltip: React.FC<Props> = (props) => {
  return <RCTooltip {...props} />;
};
